import NinjaTable from 'components/tables/NinjaTable';
import React from 'react';
import DisconnectButton from 'modules/apps/components/DisconnectButton';

const columns = [
  {
    key: 'id',
    frozen: true,
    name: 'ID',
    resizable: true,
  },
  {
    key: 'name',
    frozen: true,
    name: 'Name',
    resizable: true,
  },
  {
    key: 'currency',
    frozen: true,
    name: 'Currency',
    resizable: true,
  },
  {
    key: 'domain',
    frozen: true,
    name: 'URL',
    resizable: true,
  },
  {
    key: 'disconnect',
    name: 'disconnect',
    width: 130,
    renderCell: ({ row }) => {
      return <DisconnectButton integration='shopify' id={row.id} name={row.name} />;
    },
  },
];

const ConnectedShopifyStores = (props) => {
  return (
    <NinjaTable
      title='Connected stores'
      columns={columns}
      dataProvider='integrationList'
      queryParams={{ integration: 'shopify' }}
      disableFooter
    />
  );
};

export default ConnectedShopifyStores;
